import React from "react";
import { Box, Button, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import { SYSTEM_LANGUAGE_LABELS } from "../../shared/enums/shared-enums";
import TeamTable from "../../components/tables/TeamTable";
import { Team } from "../../types/team";

interface MainTeamPagePageProps {
  systemLanguageType: Team["system_language_type"];
}

const MainTeamPage: React.FC<MainTeamPagePageProps> = ({
  systemLanguageType,
}) => {
  const navigate = useNavigate();
  const languageLabel = SYSTEM_LANGUAGE_LABELS[systemLanguageType];

  return (
    <Box>
      <Box
        sx={{
          mb: 4,
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Button
          variant="contained"
          color="primary"
          sx={{
            position: "absolute",
            left: 16,
          }}
          startIcon={<AddIcon />}
          onClick={() => navigate("create")}
        >
          Create Team
        </Button>

        <Typography variant="h1">
          {languageLabel ? `${languageLabel} Teams` : "Teams"}
        </Typography>
      </Box>
      <TeamTable
        filters={{
          system_language_type: systemLanguageType,
        }}
      />
    </Box>
  );
};

export default MainTeamPage;
